module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.1ec87d3c.woff";